import { render } from "./presentationApp.vue?vue&type=template&id=0e4de7ea"
import script from "./presentationApp.vue?vue&type=script&lang=js"
export * from "./presentationApp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__